<div [formGroup]="mailingAddressForm">
    <div fxFlex>
        <div *ngFor="let address of mailingAddresses" fxLayout="column" fxLayoutAlign="space-between stretch" fxLayoutGap>
            <mailing-address *ngIf="!isDeleted(address)" formArrayName="rows" [mailingAddress]="address" [viewOnly]="viewOnly" [usages]="getAddressUsages(address)" [refresh]="refresh" (edit)="onEdit(address)" (primaryChanged)="onPrimaryChanged(address)" (forwardingChanged)="onForwardingChanged(address)" (certify)="onCertify(address)" (delete)="onDelete(address)">
            </mailing-address>
        </div>
    </div>

    <div *ngIf="invalid" fxLayoutAlign="center start" class="error">
        <div>The Mailing Address(es) could not be saved:</div>
        <ul>
            <li *ngIf="hasAtLeastOneError">
                There must be at least one Mailing Address
            </li>
            <li *ngIf="hasNoPrimaryError">
                Please Select a Primary Mailing Address
            </li>
        </ul>
    </div>
</div>
